import React from "react";

/**
 * Loading component for displaying a loading spinner.
 */
const Loading: React.FC = () => {
  return (
    <div className="absolute inset-0 flex items-center justify-center">
      <div className="block mx-auto loading loading-spinner loading-lg text-primary">
        Caricamento…
      </div>
    </div>
  );
};

export default Loading;
